import { render, staticRenderFns } from "./CoachStaffPosition.vue?vue&type=template&id=710048c5&scoped=true&"
import script from "./CoachStaffPosition.vue?vue&type=script&lang=ts&"
export * from "./CoachStaffPosition.vue?vue&type=script&lang=ts&"
import style0 from "./CoachStaffPosition.vue?vue&type=style&index=0&id=710048c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710048c5",
  null
  
)

export default component.exports